const claimsList = state => {
return state.claimsList
}

const formUserList = state => {
return state.formUserList
}
const taskHistoryList = state => {
return state.taskHistoryList
}
const documentTypes = state => {
return state.documentTypes
}

const declinationReasons = state => {
return state.declinationReasons
}

const manualStatuses = state => {
return state.manualStatuses
}

const resellers = state => {
return state.resellers
}

const underwriters = state => {
    return state.underwriters
}

const taskTypes = state => {
return state.taskTypes
}

const taskTypesOutstanding = state => {
return state.taskTypesOutstanding
}

const repairProviders = state => {
return state.repairProviders
}

const repairOptionTypes = state => {
return state.repairOptionTypes
}

const incidentTypes = state => {
return state.incidentTypes
}

const incidentTypesDisplayLabel1 = state => {
let result = state.incidentTypes.map(a => { return { id: a.id, label: a.displayLabel1 }; })
return result
}

const selectedClaim = state => {
return state.selectedClaim
}

const emailPreview = state => {
return state.emailPreview
}

const isLoading = state => {
return state.loading
}

const pageNumber = state => {
let { pagenation } = state
if (pagenation) {
return pagenation.pageNumber
}
return 1
}

const pageSize = state => {
let { pagenation } = state
if (pagenation) {
return pagenation.pageSize
}
return 5
}

const totalRecords = state => {
let { pagenation } = state
if (pagenation) {
return pagenation.totalRecords
}
return 0
}

const approveRoute = state => routeName => {
let { routes } = state
let route = routes.filter(r => r.routeName == routeName)
if (route) {
return route[0].approveRoute
}
return '/'
}

const popoutUrl = state => routeName => {
let { routes } = state
let route = routes.filter(r => r.routeName == routeName)
if (route && route.length > 0) {
return route[0].popoutUrl
}
return null
}

const pipelineList = state => {
return state.pipelines
}

const pipelineTypeList = state => {
return state.pipelineTypes
}
const resellerPipelineList = state => {
return state.resellerPipelines
}

const selectedResellerPipeline = state => {
return state.selectedResellerPipeline
}

const selectedPipeline = state => {
return state.selectedPipeline
}

const pipelineRuleList = state => {
return state.pipelineRules
}

const selectedPipelineRule = state => {
return state.selectedPipelineRule
}

const ruleParameterList = state => {
return state.ruleParameters
}

const ruleComponents = state => {
return state.ruleComponents
}

const repairOptionInstructions = state => {
return state.repairOptionInstructions
}

const selectedOptionInstructions = state => {
return state.selectedOptionInstructions
}

const selectedClaimIndex = state => {
return state.selectedClaimIndex
}

const repairOptionMatrix = state => {
return state.repairOptionMatrix
}

const deviceTypes = state => {
return state.deviceTypes
}

const deviceMakes = state => {
return state.deviceMakes
}

const selectedClaimPolicyDetails = state => {
if (state.selectedClaim) {
return state.selectedClaim.policyDetails
}

return null
}

const selectedClaimPolicyImported = state => {
if (state.selectedClaim) {
let { policyDetails } = state.selectedClaim
if (policyDetails) {
//console.log('policyDetails = ', policyDetails)
let { resellerId, productId } = policyDetails
return resellerId > 0 && productId > 0
}
}
return false
}

const salesDocumentUploads = state => {
return state.salesDocumentUploads
}

const gadgetOptionsPreview = state => {
return state.gadgetOptionsPreview
}

const repairOptionWebDisplay = state => {
return state.repairOptionWebDisplay
}

const emailTemplates = state => {
return state.emailTemplates
}

//---------------------------------------------------------------------------------------------//
//    RR Options
//---------------------------------------------------------------------------------------------//
const manDeviceRepairPreConfigItems = state => {
    return state.manDeviceRepairPreConfigItems
}

const selectedRROptionsForSelectedClaim = state => {
    if (state.selectedClaim && state.selectedClaim.selectedRepairOptionDetails) {
        return state.selectedClaim.selectedRepairOptionDetails.map(o => ({ ...o, displayLabel: `${o.makeLabel} - ${o.modelLabel} - ${o.serialNo || o.imeiNo}` }))
    } else {
        return []
    }
}

const gadgetsDisplayLabelForSelectedClaim = state => {
    if (state.selectedClaim) {
        let { gadgetDetails } = state.selectedClaim
        if (gadgetDetails) {
            return gadgetDetails
                .filter(o => {
                    if (typeof (o.disabled !== 'undefinded') && o.disabled == true)
                        return false;
                    else
                        return true;
                })
                .map(o => ({ id: o.id, webReference: o.webReference, itemGuid: o.itemGuid, displayLabel: `${o.makeLabel} - ${o.modelLabel} - ${o.serialNo || o.imeiNo}` }))
        } else {
            return null
        }
    } else {
        return null
    }
}

const selectedRROptionHistoryForGadget = (state, getters) => id => {
    if (getters.selectedRROptionsForSelectedClaim) {
        return getters.selectedRROptionsForSelectedClaim.filter(e => { return e.gadgetId == id; })
    } else {
        return []
    }
}

const currentSelectedRROptionForGadget = (state, getters) => id => {
    let mostRecentObject = null
    try {
        let mostRecentDate = new Date(Math.max.apply(null, getters.selectedRROptionHistoryForGadget(id).map(e => {
            return new Date(e.dateCreated);
        })));
        if (mostRecentDate != null) {
            mostRecentObject = getters.selectedRROptionHistoryForGadget(id).filter(e => {
                var d = new Date(e.dateCreated);
                return d.getTime() == mostRecentDate.getTime();
            })[0];
        }
    }
    catch (err) {
        console.log('currentSelectedRROptionForGadget: ', err)
    }
    return mostRecentObject
}
//---------------------------------------------------------------------------------------------//

const selectedClaimGadgetByWebRef = (state, getters) => webRef => {
    if (getters.selectedClaim && getters.selectedClaim.gadgetDetails) {
        return getters.selectedClaim.gadgetDetails.find(g => g.webReference == webRef)
    } else {
        return null
    }
}

const selectedClaimApproved = (state, getters) => {
    if (getters.selectedClaim) {
        return getters.selectedClaim.approved
    } else {
        return false
    }
}

const claimDocumentsLoading = (state, getters) => {
   return state.claimDocumentsLoading
}

export default {
    claimsList,
    formUserList,
    taskHistoryList,
    documentTypes,
    declinationReasons,
    manualStatuses,
    resellers,
    taskTypes,
    taskTypesOutstanding,
    repairProviders,
    repairOptionTypes,
    incidentTypes,
    incidentTypesDisplayLabel1,
    selectedClaim,
    emailPreview,
    isLoading,
    pageNumber,
    pageSize,
    totalRecords,
    approveRoute,
    popoutUrl,
    pipelineList,
    pipelineTypeList,
    resellerPipelineList,
    selectedResellerPipeline,
    selectedPipeline,
    pipelineRuleList,
    selectedPipelineRule,
    ruleParameterList,
    ruleComponents,
    repairOptionInstructions,
    selectedOptionInstructions,
    selectedClaimIndex,
    repairOptionMatrix,
    deviceTypes,
    deviceMakes,
    selectedClaimPolicyDetails,
    selectedClaimPolicyImported,
    salesDocumentUploads,
    gadgetOptionsPreview,
    repairOptionWebDisplay,
    emailTemplates,
    manDeviceRepairPreConfigItems,
    selectedRROptionsForSelectedClaim,
    gadgetsDisplayLabelForSelectedClaim,
    selectedRROptionHistoryForGadget,
    currentSelectedRROptionForGadget,
    selectedClaimGadgetByWebRef,
    selectedClaimApproved,
    underwriters,
    claimDocumentsLoading
}